import { calculateFinalPositions } from "model/Positions";
import { mapRoundsFormat } from "./FsRoundsFormat";
import { MatchTeams } from "model/Match/MatchTeams";
import { mapRoundsTracks } from "./FsRoundsTrack";
import { nonUndefined } from "Utility";
import { applyScoreOverrides, Scores } from "model/Scores";
import { RoundsSet } from "model/Match/Set/Rounds/RoundsSet";
import { FsRoundsSet } from "db/model/match/Set/Rounds/FsRoundsSet";
import { mapMatchSetBase } from "../FsMatchSet";

export const mapRoundsSet = (
  fsModel: FsRoundsSet,
  teams: MatchTeams
): RoundsSet | undefined => {
  if (!fsModel.format) {
    return undefined;
  }

  const format = mapRoundsFormat(fsModel.format);
  if (!format) {
    return undefined;
  }

  const scores: Scores = {};
  const tracks = mapRoundsTracks(
    nonUndefined(fsModel.tracks ?? []),
    teams.rosters,
    teams.scope,
    scores,
    format.points,
    format.roundsPerTrack
  );

  const numCompleteTracks = tracks.filter((t) => t.isComplete).length;
  applyScoreOverrides(scores, fsModel.scoreOverrides);
  const isComplete =
    fsModel.overrideComplete || format.numTracks === numCompleteTracks;

  const finalPositions = calculateFinalPositions(
    isComplete,
    scores,
    compareScores
  );

  return {
    ...mapMatchSetBase(fsModel, isComplete, finalPositions, scores),
    format,
    tracks,
    type: "Rounds",
  };
};

// todo - Apply tiebreakers here
const compareScores = (scores: Scores, a: string, b: string) => {
  return scores[b] - scores[a];
};
